import { IRevenueSpendByAccountOfferSpendDetailsTableLang } from '../../../types/lang'

export const revenueSpendByAccountOfferSpendDetailsTableLang: IRevenueSpendByAccountOfferSpendDetailsTableLang = {
	revenue_spend_by_account_offer_spend_details_table: {
		column_id: 'ID_ua',
		column_date: 'Date_ua',
		column_amount: 'Amount_ua',
		column_percent: 'Percent, %_ua',
		column_offer: 'Offer_ua',
		column_scope: 'Scope_ua',
		column_notes: 'Notes_ua'
	}
}